import React from "react";
import { Link } from "react-router-dom";
import { Copy, ExternalLink, Pencil, Star } from "lucide-react";
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
} from "../../../components/ui/context-menu";

interface RepositoryContextMenuProps {
  children: React.ReactNode;
  owner: string;
  name: string;
  repoUrl: string;
  isFavorite: boolean;
  onToggleFavorite: () => void;
}

const RepositoryContextMenu = ({
  children,
  owner,
  name,
  repoUrl,
  isFavorite,
  onToggleFavorite,
}: RepositoryContextMenuProps) => {
  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>{children}</ContextMenuTrigger>
      <ContextMenuContent className="w-56">
        <ContextMenuItem asChild>
          <Link to={`/edit/${owner}/${name}`}>
            <Pencil className="mr-2 h-4 w-4" /> Open editor
          </Link>
        </ContextMenuItem>
        <ContextMenuItem asChild>
          <Link to={repoUrl} target="_blank">
            <ExternalLink className="mr-2 h-4 w-4" /> Open on GitHub
          </Link>
        </ContextMenuItem>
        <ContextMenuItem onClick={() => navigator.clipboard?.writeText(repoUrl)}>
          <Copy className="mr-2 h-4 w-4" /> Copy repository link
        </ContextMenuItem>
        <ContextMenuItem onClick={onToggleFavorite}>
          <Star className="mr-2 h-4 w-4" />
          {isFavorite ? "Remove favorite" : "Add favorite"}
        </ContextMenuItem>
      </ContextMenuContent>
    </ContextMenu>
  );
};

export default RepositoryContextMenu;
